import { createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-48c22c74")

_pushScopeId("data-v-48c22c74")
const _hoisted_1 = {
  style: {"width":"42rem"},
  class: "relative pt-6 edit-body overflow-y-auto"
}
const _hoisted_2 = { class: "flex flex-col w-full pr-16" }
const _hoisted_3 = /*#__PURE__*/_createVNode("p", { class: "text-12px text-gray-lp-500 mb-6" }, [
  /*#__PURE__*/_createTextVNode(" Masukan jumlah top up yang akan disetujui. Pastikan bukti transfer sudah benar dan sesuai"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode("dengan jumlah permintaan. ")
], -1)
const _hoisted_4 = { class: "grid grid-cols-3 gap-x-16text-black-lp-300" }
const _hoisted_5 = { class: "mt-4" }
const _hoisted_6 = { class: "mt-4" }
const _hoisted_7 = { class: "flex flex-row justify-end pt-12" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_data_wrapper = _resolveComponent("data-wrapper")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Dialog, {
      modelValue: _ctx.showTopupApprovalForm && !_ctx.isSuccessSubmit,
      persistent: true,
      title: "Persetujuan Top Up",
      class: "topup-approval-form",
      "onUpdate:modelValue": _cache[4] || (_cache[4] = 
      () => {
        _ctx.showModalFormTopupApproval(false);
        _ctx.showCloseConfirmModal = true;
      }
    )
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _hoisted_3,
            _createVNode("div", _hoisted_4, [
              _createVNode(_component_data_wrapper, { label: "Jumlah Permintaan" }, {
                default: _withId(() => [
                  _createVNode("div", _hoisted_5, _toDisplayString(_ctx.formatPrice(_ctx.detailData.tumAmount)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_data_wrapper, { label: "Jumlah Terverifikasi" }, {
                default: _withId(() => [
                  _createVNode("div", _hoisted_6, _toDisplayString(_ctx.formatPrice(_ctx.detailData.tumVerifiedAmount)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_data_wrapper, { label: "Jumlah Disetujui" }, {
                default: _withId(() => [
                  _createVNode(_component_lp_input, {
                    class: "mt-2",
                    placeholder: "e.g 100.000",
                    modelValue: _ctx.approvedAmount,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.approvedAmount = $event)),
                    format: _ctx.formatMoney,
                    onBlur: _ctx.onAmountBlur,
                    prefix: "IDR",
                    error: _ctx.errorAmountToBeApprove
                  }, null, 8, ["modelValue", "format", "onBlur", "error"])
                ]),
                _: 1
              })
            ])
          ]),
          _createVNode("div", _hoisted_7, [
            _createVNode(_component_button_fill, {
              onClick: _cache[2] || (_cache[2] = 
            () => {
              _ctx.showModalFormTopupApproval(false);
              _ctx.showCloseConfirmModal = true;
            }
          ),
              title: "Batal",
              class: "text-red-lp-300 border border-red-lp-300 mr-5",
              style: {"background-color":"#fff","width":"135px"}
            }),
            (_ctx.permissionCheck)
              ? (_openBlock(), _createBlock(_component_button_fill, {
                  key: 0,
                  isDisabled: !_ctx.isFormValid,
                  onClick: _cache[3] || (_cache[3] = 
            () => {
              if (!_ctx.isLoading && _ctx.isFormValid) {
                _ctx.showModalFormTopupApproval(false);
                _ctx.showConfirmModal = true;
              }
            }
          ),
                  title: "Approve",
                  class: "bg-red-lp-300",
                  style: {"width":"135px"},
                  isLoading: _ctx.isLoading
                }, null, 8, ["isDisabled", "isLoading"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: () => _ctx.onSubmit(),
      onClose: 
      () => {
        _ctx.showModalFormTopupApproval(true);
        _ctx.showConfirmModal = false;
      }
    ,
      title: "Konfirmasi Persetujuan",
      message: 
      `Sebelum menyetujui permintaan ini, pastikan bukti transfer sudah benar dan sesuai dengan jumlah permintaan.`
    ,
      image: "are-you-sure",
      textSuccess: "Approve",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "message"]), [
      [_vShow, _ctx.showConfirmModal]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: 
      () => {
        _ctx.setSuccessSubmit(false);
      }
    ,
      title: "Persetujuan Berhasil !",
      message: `Permintaan top up berhasil disetujui. `,
      image: "image-modal-success",
      textSuccess: "Oke",
      class: "px-8"
    }, null, 8, ["onSubmit", "message"]), [
      [_vShow, _ctx.isSuccessSubmit]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.goToDetail,
      onClose: 
      () => {
        _ctx.showCloseConfirmModal = false;
        _ctx.showModalFormTopupApproval(true);
      }
    ,
      title: "Yakin ingin keluar?",
      message: "Pastikan kembali, Anda akan kehilangan semua data jika Anda keluar halaman ini.",
      image: "are-you-sure",
      textSuccess: "Keluar",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose"]), [
      [_vShow, _ctx.showCloseConfirmModal]
    ])
  ], 64))
})